import Body from './body';

export default {
  header: null,
  body: Body,
  settings: null
};
